<script setup lang="ts">
import { ElTag } from 'element-plus'
import { computed } from 'vue'
import { ContractStatus } from '@/types/customer'
import { Document } from '@element-plus/icons-vue'

interface Props {
  status: ContractStatus
  size?: 'large' | 'default' | 'small'
}

const props = withDefaults(defineProps<Props>(), {
  size: 'large'
})

const statusText = computed(() => {
  switch (props.status) {
    case ContractStatus.active: return 'Aktivní'
    case ContractStatus.inactive: return 'Neschválená'
    case ContractStatus.cancelled: return 'Stornovaná'
    default: return 'Neznámý'
  }
})

const statusType = computed(() => {
  switch (props.status) {
    case ContractStatus.active: return 'success'
    case ContractStatus.inactive: return 'warning'
    case ContractStatus.cancelled: return 'danger'
    default: return 'info'
  }
})
</script>

<template>
  <el-tooltip :content="statusText" placement="top" :disabled="size !== 'small'">
    <el-tag :type="statusType" :size="size" effect="light" to>
      <Document v-if="size == 'small'" style="width: 1.3em; height: 1.3em;" />
      <span v-else>{{ statusText }}</span>
    </el-tag>
  </el-tooltip>
</template>
